<template>
  <div class="news_detail ">
    <headd></headd>
    <div class="container detail">
      <span class="title">{{ detail.title }}</span>
      <div class="info">
        <span>发表时间：{{ detail.createdAt }}</span>
        <span>浏览：{{ detail.view_num }}</span>
      </div>
      <div class="contentnews" v-html="page_content"></div>
    </div>
    <indexbanner :adbannerlist="banner_1" :config="config_1"></indexbanner>
    <foot></foot>
  </div>
</template>

<script>
import indexbanner from "../../components/indexbanner";
import headd from "@/components/head";
import foot from "@/components/foot";
import { getappads, getzixundetail } from "../api/api"; //引入api里面定义的方法
export default {
  data() {
    return {
      id: 0,
      detail: {},
      page_content: "",
      banner_1: [],
      config_1: true
    };
  },
  metaInfo: {
    title: "马上创业网 专注企业注册的网站", // set a title
    meta: [
      {
        // set meta
        name: "keyWords",
        content:
          "马上创业网，注册公司，代理记账，上海注册公司，注册公司流程，注册公司费用，商标注册，法务咨询，法律服务，个体工商户注册，许可证办理，专业法律，社保，公积金，专利申请，医疗器械许可证，ICP电信增值许可证，食品经营许可证，酒类经营许可证，餐饮服务许可证，道路运输许可证，广播电视节目许可证，海关资质，进出口许可证，商标设计，logo设计，VI设计，海报设计，包装设计，APP开发，微信运营，网站定制，版权服务，软件著作权，发明专利，外观设计专利，实用新型专利，商标转让，驳回复审，注销公司，股权变更，经营范围变更，股权协议，股权转让，劳务派遣"
      },
      {
        name: "description",
        content:
          "马上创业网是一个专为中小企业服务的综合平台，主要提供医疗器械服务、审计服务、知识产权服务、财税咨询、注册公司、代理记账、商标注册、专利申请、社保代理、法务代理等一站式的服务，借助移动互联网技术，改善并升级企业服务状态，实现了新形势下中小企业所需要的企业服务。"
      }
    ]
  },
  components: {
    indexbanner,
    headd,
    foot
  },
  async mounted() {
    var appads1 = await getappads("zixun_ads");
    this.banner_1 = appads1.data.data.appads;
    this.getNewsDetail();
  },
  methods: {
    async getNewsDetail() {
      //console.log(this.$route.query);
      let parameters = this.$store.getters.parameters;
      console.log(parameters);
      var parm = this.$route.params;
      var _self = this;
      var data = {
        id: parm.id
      };
      const res = await getzixundetail(data);
      this.detail = res.data.data;
      var content = res.data.data.page_content;
      const regex = new RegExp("<img", "gi");
      content = content.replace(
        regex,
        `<img style="max-width: 100%; height: auto"`
      );
      this.page_content = content;
      //   this.page_content = graceRichText.format(res.data.data.page_content);
    },
    async getappads(adstype) {
      var _self = this;
      const res = await this.$myRuquest({
        url: "/appads",
        method: "GET",
        data: {
          adstype: adstype
        }
      });

      _self.banner_1 = res.data.data.appads;

      //console.log(res)
    }
  },

  onLoad(options) {
    this.id = options.id;
    this.getNewsDetail();
    this.getappads("zixun_ads");
    this.$logindex();
  }
};
</script>

<style lang="less">
.container {
  @media (max-width: 991px) {
    padding: 0;
  }
}
.news_detail {
  font-size: 0.3rem;
  padding: 0 0rem;
  flex-direction: column;
  display: flex;
  margin-bottom: 0.3rem;
  @media (max-width: 991px) {
    width: 6.86rem;
    margin: auto;
  }
  .detail {
    width: 10rem;
    @media (max-width: 991px) {
      width: 100%;
      margin: 0;
    }
  }

  .title {
    text-align: left;
    width: auto;
    display: block;
    margin: 0.2rem 0 0.4rem 0;
    font-size: 0.24rem;
    font-weight: bolder;
    @media (max-width: 991px) {
      font-size: 0.44rem;
    }
  }

  .info {
    display: flex;
    justify-content: space-between;
    margin-bottom: 0.5rem;
    font-size: 0.16rem;
    line-height: 0.25rem;
    @media (max-width: 991px) {
      font-size: 0.3rem;
      line-height: 0.3rem;
    }
  }

  .contentnews {
    font-size: 0.14rem;
    line-height: 0.25rem;
    color: #1b1c33;
    text-align: left;
    text-indent: 0.28rem;
    margin-bottom: 0.3rem;
    @media (max-width: 991px) {
      font-size: 0.36rem;
      line-height: 0.5rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/news-detail/news-detail.vue